import React from 'react';
import { ReactComponent as CocoLightSvg } from '../../assets/coco_light.svg';
import SvgIcon, { SvgIconTypeMap } from '@mui/material/SvgIcon';

export default function CocoLightIcon(props: SvgIconTypeMap<object, 'svg'>['props']) {
  return <SvgIcon component={CocoLightSvg} inheritViewBox {...props} />;
}
